import { useChain, CHAINS } from "../context/ChainContext";

const ITEMS = [CHAINS.solana, CHAINS.robinhood];

export const ChainToggle = () => {
  const { chain, setChain } = useChain();
  const active = CHAINS[chain] || CHAINS.solana;

  return (
    <div
      data-testid="chain-toggle"
      className="relative flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5 border-2 rounded-2xl px-4 sm:px-6 py-3.5 bg-black/60 backdrop-blur transition-colors"
      style={{ borderColor: active.color, boxShadow: `0 0 34px ${active.color}44, inset 0 0 20px ${active.color}11` }}
    >
      {/* animated glow ring so it never blends into the background */}
      <span
        aria-hidden
        className="pointer-events-none absolute -inset-[3px] rounded-2xl animate-pulse"
        style={{ boxShadow: `0 0 26px ${active.color}55`, opacity: 0.6 }}
      />
      <div className="flex items-center gap-2 shrink-0 z-10">
        <span className="w-2.5 h-2.5 rounded-full animate-pulse" style={{ background: active.color }} />
        <span className="font-mono text-[11px] tracking-[0.25em] text-muted-foreground uppercase">Switch market</span>
      </div>

      <div className="inline-flex items-center gap-1.5 p-1.5 rounded-xl bg-white/5 border border-white/10 z-10 self-start sm:self-auto">
        {ITEMS.map((c) => {
          const on = chain === c.id;
          return (
            <button
              key={c.id}
              data-testid={`chain-${c.id}`}
              onClick={() => setChain(c.id)}
              className="relative flex items-center gap-2 px-5 sm:px-7 py-2.5 rounded-lg font-heading font-black text-base sm:text-lg tracking-tight transition-all duration-200"
              style={
                on
                  ? { background: c.color, color: "#04120b", boxShadow: `0 0 22px ${c.color}aa`, transform: "scale(1.04)" }
                  : { color: "#9aa0a6" }
              }
            >
              <span className="text-lg leading-none">{c.glyph}</span>
              {c.short}
              {c.id === "robinhood" && !on && (
                <span className="absolute -top-2 -right-2 text-[8px] font-mono font-bold px-1.5 py-0.5 rounded-full bg-[#CCFF00] text-black animate-bounce">NEW</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};
